import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
  > div {
    flex: 1 1 20%;
    border: 1px solid #b6dbfb;
    background: #e7f3fe94;
    padding: 16px;
    border-radius: 8px;
    overflow: hidden;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    svg {
      background: #cfe7fd;
      padding: 4px;
      border-radius: 4px;
      font-size: 16px;
    }
    span {
      font-weight: 700;
      font-size: 16px;
    }
    @media (max-width: 768px) {
      flex: 1 1 100%;
    }
  }
`

export const Buttons = styled.div`
  text-align: right;
  margin-top: 16px;
  button {
    height: 40px;
    padding: 0 12px;
    margin-left: 16px;
    border-radius: 8px;
    font-weight: 700;
    border: none;
    box-shadow: none;
    background: #e7f3fe !important;
    color: #0085ff !important;
    &:hover {
      background: #d6ecff !important;
    }
    svg {
      margin-left: 6px;
    }
  }
  @media (max-width: 768px) {
    button {
      width: 100%;
      margin-left: 0;
    }
  }
`
